import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-cat-execution',
    templateUrl: './cat-execution.component.html',
    styleUrls: ['./cat-execution.component.scss'],
    standalone: false
})
export class CatExecutionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
